import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import './App.css';

import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { SponsorMarquee } from './components/SponsorMarquee';
import { SideSponsorSlider } from './components/SideSponsorSlider';

import Home from './pages/Home';
import Sponsors from './pages/Sponsors';
import Games from './pages/Games';
import Draws from './pages/Draws';
import Store from './pages/Store';
import Contact from './pages/Contact';

function App() {
  return (
    <Router>
      <div className="App" style={{ minHeight: '100vh', position: 'relative' }}>
        {/* Background overlays */}
        <div className="casino-pattern-overlay" data-testid="casino-pattern-overlay" />
        <div className="noise-overlay" />

        {/* Side sliders (desktop only) */}
        <SideSponsorSlider />

        {/* Main content */}
        <div style={{ position: 'relative', zIndex: 1 }}>
          <Navbar />
          <SponsorMarquee />

          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/sponsorlar" element={<Sponsors />} />
              <Route path="/sans-oyunlari" element={<Games />} />
              <Route path="/cekilisler" element={<Draws />} />
              <Route path="/store" element={<Store />} />
              <Route path="/iletisim" element={<Contact />} />
            </Routes>
          </main>

          <Footer />
        </div>

        <Toaster position="bottom-right" richColors />
      </div>
    </Router>
  );
}

export default App;
